module.exports = __webpack_public_path__ + "static/img/2-1.1dbabb5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/2-1.jpg
// module id = 1yOP
// module chunks = 1